import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, Grid, NumberInput, Stack } from "@mantine/core";

import { useCreateCampaignInquiryFormContext } from "./formContext";

export interface CreateCampaignInquiryPricingFormProps {}
export const CreateCampaignInquiryPricingForm = ({}: CreateCampaignInquiryPricingFormProps) => {
    const { t } = useTranslation(["common"]);

    const createCampaignInquiryForm = useCreateCampaignInquiryFormContext();

    const handleIsFreeChange = useCallback((isFree: boolean) => {
        createCampaignInquiryForm.setFieldValue("pricing.isFree", isFree);

        if (isFree) {
            createCampaignInquiryForm.setFieldValue("pricing.discountPercent", 100);
            return;
        }

        createCampaignInquiryForm.setFieldValue("pricing.discountPercent", 0);
    }, [createCampaignInquiryForm]);

    const handleDiscountPercentChange = useCallback((discountPercent: number) => {
        createCampaignInquiryForm.setFieldValue("pricing.discountPercent", discountPercent);

        if (discountPercent >= 100) {
            createCampaignInquiryForm.setFieldValue("pricing.isFree", true);
        }
    }, [createCampaignInquiryForm]);

    return (
        <Grid>
            <Grid.Col xs={12} sm={6} md={6}>
                <Stack>
                    <Box w="auto" mr="sm">
                        <Checkbox
                            {...createCampaignInquiryForm.getInputProps("pricing.isFree")}
                            color="dark"
                            label={t("campaign_pricing_isfree")}
                            checked={createCampaignInquiryForm.values?.pricing?.isFree}
                            onChange={event =>
                                handleIsFreeChange(event?.target?.checked)}
                        />
                    </Box>
                    <Box style={{ flex: 1 }}>
                        <NumberInput
                            {...createCampaignInquiryForm.getInputProps("pricing.discountPercent")}
                            disabled={createCampaignInquiryForm.values?.pricing?.isFree}
                            label={t("campaign_pricing_discount")}
                            placeholder={t("campaign_pricing_discount")}
                            type="number"
                            min={0}
                            max={100}
                            onChange={discountPercent =>
                                handleDiscountPercentChange(Number(discountPercent))}
                        />
                    </Box>
                </Stack>
            </Grid.Col>
            <Grid.Col xs={12} sm={6} md={6}>
                {/* <Flex style={{ height: "100%" }} align="flex-end">
                    <Box style={{ flex: 1 }}>
                        <DiscountCodesEditor
                            label={t("campaign_pricing_discountcodes")}
                            description={t("campaign_pricing_discountcodes_count", {
                                count: createCampaignInquiryForm.values?.pricing?.discountCodes?.length || 0,
                            })}
                            value={createCampaignInquiryForm.values?.pricing?.discountCodes}
                            onChange={discountCodes =>
                                createCampaignInquiryForm.setFieldValue("pricing.discountCodes", discountCodes)}
                        />
                    </Box>
                    <Button
                        onClick={() =>
                            ImportDiscountCodesModal.display({
                                currentDiscountCodes: createCampaignInquiryForm.values?.pricing?.discountCodes || [],
                                onSave: discountCodes =>
                                    createCampaignInquiryForm.setFieldValue("pricing.discountCodes", discountCodes),
                            })
                        }
                    >
                        {t("add")}
                    </Button>
                </Flex> */}
            </Grid.Col>
        </Grid>
    );
};
